import { Requester } from './Requester';
import { IContactRecord, TableQueryParams } from '../types';

export const GetContacts = async (
    options: TableQueryParams
): Promise<{ contacts: IContactRecord[]; totalRecords: number } | null> => {
    try {
        const response = await Requester<{ contacts: IContactRecord[]; totalRecords: number }>({
            // port: '8080',
            path: 'contacts/paged',
            method: 'PUT',
            payload: options
        });
        if ('contacts' in response && Array.isArray(response.contacts)) return response;
        return null;
    } catch (e) {
        console.error('Get contacts request failed');
        return Promise.reject(e);
    }
};
